/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactScriptExecutionResult } from './ContactScriptExecutionResult.js';
import {
    ContactScriptExecutionResultFromJSON,
    ContactScriptExecutionResultFromJSONTyped,
    ContactScriptExecutionResultToJSON,
} from './ContactScriptExecutionResult.js';

/**
 * 
 * @export
 * @interface GetScriptLogsResponse
 */
export interface GetScriptLogsResponse {
    /**
     * 
     * @type {Array<ContactScriptExecutionResult>}
     * @memberof GetScriptLogsResponse
     */
    data?: Array<ContactScriptExecutionResult>;
    /**
     * 
     * @type {number}
     * @memberof GetScriptLogsResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetScriptLogsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetScriptLogsResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetScriptLogsResponse
     */
    errors?: Array<Error>;
    /**
     * 
     * @type {boolean}
     * @memberof GetScriptLogsResponse
     */
    isLoggingEnabled?: boolean;
}

/**
 * Check if a given object implements the GetScriptLogsResponse interface.
 */
export function instanceOfGetScriptLogsResponse(value: object): boolean {
    return true;
}

export function GetScriptLogsResponseFromJSON(json: any): GetScriptLogsResponse {
    return GetScriptLogsResponseFromJSONTyped(json, false);
}

export function GetScriptLogsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetScriptLogsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ContactScriptExecutionResultFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
        'isLoggingEnabled': json['isLoggingEnabled'] == null ? undefined : json['isLoggingEnabled'],
    };
}

export function GetScriptLogsResponseToJSON(value?: GetScriptLogsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ContactScriptExecutionResultToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
        'isLoggingEnabled': value['isLoggingEnabled'],
    };
}

